// Internal Dependencies
import {
  BADGES_FETCH,
  CODER_SINGLE_FETCH,
  CODERS_ATTENDANCE_FETCH,
  CODERS_BADGES_FETCH,
  CODERS_FETCH,
  EVENT_FETCH,
} from './action-types';

export const fetchBadgesAction = badges => ({
  type: BADGES_FETCH,
  payload: badges,
});

export const fetchCoderAttendanceAction = coderAttendance => ({
  type: CODERS_ATTENDANCE_FETCH,
  payload: coderAttendance,
});

export const fetchCoderBadgesAction = coderBadges => ({
  type: CODERS_BADGES_FETCH,
  payload: coderBadges,
});

export const fetchCodersAction = coders => ({
  type: CODERS_FETCH,
  payload: coders,
});

export const fetchCoderSingleAction = coderSingle => ({
  type: CODER_SINGLE_FETCH,
  payload: coderSingle,
});

export const eventFetchSuccess = eventData => ({
  type: EVENT_FETCH,
  payload: eventData,
});



/** WEBPACK FOOTER **
 ** ./src/state/actions/action-creator.js
 **/